"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var VisibleNote_1 = require("./VisibleNote");
var NewNote_1 = require("./NewNote");
var EditableNote_1 = require("./EditableNote");
var Page_1 = require("../../Page");
var operators_1 = require("rxjs/operators");
var CustomerNotes = /** @class */ (function (_super) {
    __extends(CustomerNotes, _super);
    function CustomerNotes(props) {
        var _this = _super.call(this, props) || this;
        _this.notesLimit = 100;
        _this.setShowNewNote = function (state) {
            _this.setState({ showNewNote: state });
        };
        _this.setNewNoteText = function (state) {
            _this.setState({ newNoteText: state });
        };
        _this.setEditableNoteId = function (state) {
            _this.setState({ editableNoteId: state });
        };
        _this.setEditableNoteText = function (state) {
            _this.setState({ editableNoteText: state });
        };
        _this.getNotes = function (reset) {
            if (reset === void 0) { reset = true; }
            var offset = reset ? 0 : _this.state.notesOffset;
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getNotes(_this.props.customerReferenceNumber, offset, _this.notesLimit)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (notes) {
                    _this.setState(function (previousState) { return ({
                        notes: reset
                            ? notes
                            : __spreadArray(__spreadArray([], previousState.notes, true), notes, true),
                        notesOffset: offset + notes.length,
                        hasMoreNotes: notes.length === _this.notesLimit
                    }); });
                });
            });
        };
        _this.renderNotes = function () {
            if (_this.state.notes && _this.state.notes.length > 0) {
                return _this.state.notes.map(function (note) {
                    if (note.id === _this.state.editableNoteId) {
                        return (0, jsx_runtime_1.jsx)(EditableNote_1.default, __assign({ note: note, setEditableNoteId: _this.setEditableNoteId, updateNotes: _this.getNotes }, _this.props), note.id);
                    }
                    return (0, jsx_runtime_1.jsx)(VisibleNote_1.default, __assign({ note: note, setEditableNoteId: _this.setEditableNoteId, setEditableNoteText: _this.setEditableNoteText, updateNotes: _this.getNotes }, _this.props), note.id);
                });
            }
            return null;
        };
        _this.state = {
            notes: [],
            showNewNote: false,
            newNoteText: "",
            editableNoteId: "",
            editableNoteText: "",
            notesOffset: 0,
            hasMoreNotes: true
        };
        return _this;
    }
    CustomerNotes.prototype.componentDidMount = function () {
        this.getNotes();
    };
    CustomerNotes.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "customer-notes", children: [(0, jsx_runtime_1.jsx)("b", { children: "Notes" }), (0, jsx_runtime_1.jsx)("a", { className: "fas fa-plus add-note ".concat(this.state.showNewNote ? "d-none" : "d-block"), title: "Add new", onClick: function () { return _this.setState({ showNewNote: true }); } }), (0, jsx_runtime_1.jsx)(NewNote_1.default, __assign({ showNewNote: this.state.showNewNote, setShowNewNote: this.setShowNewNote, setNewNoteText: this.setNewNoteText, updateNotes: this.getNotes }, this.props)), this.renderNotes(), this.state.hasMoreNotes && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "load-older-notes pt-3", onClick: function () { return _this.getNotes(false); }, children: "Load older notes" }) }))] }));
    };
    CustomerNotes.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CustomerNotes.prototype, "supportPortalService", void 0);
    CustomerNotes = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CustomerNotes);
    return CustomerNotes;
}(React.Component));
exports.default = CustomerNotes;
//# sourceMappingURL=CustomerNotes.js.map